module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datefield"
  }, [_vm._v("\n  " + _vm._s(_vm.formattedDate) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5591011c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldDate.vue
// module id = 683
// module chunks = 0